import React from 'react';
import PropTypes from 'prop-types';
import useAdjustment from '../../utils/useAdjustment';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import formatCurrency from '@afosto/utils/formatCurrency';

const AdjustmentRow = ({ adjustment, currency }) => {
  const [name, currencyAmount] = useAdjustment(adjustment);

  return (
    <TableRow>
      <TableCell>{name}</TableCell>
      <TableCell>{formatCurrency(currencyAmount, currency)}</TableCell>
    </TableRow>
  );
};

AdjustmentRow.propTypes = {
  adjustment: PropTypes.object.isRequired,
  currency: PropTypes.string,
};

AdjustmentRow.defaultProps = {
  currency: 'EUR',
};

export default AdjustmentRow;
